import styled from "styled-components";

const Button = styled.button`
  background-image: radial-gradient(circle at 98% 98%, #ff0368, #6703ff);
  border: none;
  border-radius: 8px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.12);
  color: #ffffff;
  font-family: 'Lato', sans-serif;
  font-size: 1.0625rem;
  font-weight: 700;
  height: 56px;
  line-height: 1.41;
  margin: 0;
  padding: 0;
  transition: opacity 0.25s ease-in-out;

  &:hover {
    cursor: pointer;
    opacity: 0.85;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.jsx